import React from 'react'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import PaneBody from 'components/Common/Pane/PaneBody'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import missionAndValuesItems from './missionAndValuesItems'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

const Grid = styled.div`
  display: grid;
  gap: ${rem(24)};

  grid-template-columns: minmax(0, 1fr);

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(auto-fit, minmax(${rem(300)}, 1fr));
  }
`

const Item = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  box-shadow: ${props => props.theme.shadow.flat.small};
  padding: ${rem(16)};
  border-radius: ${props => props.theme.borderRadius.S};
`

function WhyWorkForUs() {
  return <Pane background="neutral-six">
    <PaneBody size="xl-y md">
      <LayoutContainer>
        <Group direction="vertical" gap={24}>
          <Group direction="vertical" gap={12}>
            <Heading variant="heading3" align="center" as="h2">
              Our mission and values
            </Heading>
            <BodyText variant="large" as="p" align="center">
              Make people happy by curating and selling the world's best holiday experiences.
            </BodyText>
          </Group>
          <Grid>
            {missionAndValuesItems.map((item) =>
              <Item key={item.title}>
                <Group direction="vertical" gap={12}>
                  <Group direction="horizontal" horizontalAlign="center">{item.icon}</Group>
                  <Group direction="vertical" gap={12}>
                    <BodyText variant="large" weight="bold" align="center">{item.title}</BodyText>
                    <Group direction="vertical" gap={8}>
                      {item.text.map(t =>
                        <BodyTextBlock key={t} variant="large" startIcon={<LineCheckIcon colour="primary" />}>{t}</BodyTextBlock>,
                      )}
                    </Group>
                  </Group>
                </Group>
              </Item>,
            )}
          </Grid>
        </Group>
      </LayoutContainer>
    </PaneBody>
  </Pane>
}

export default WhyWorkForUs
